import Box from '@mui/material/Box';
import { useRef } from 'react';
import { useRecoilValue } from 'recoil';
import { DICOMApprovalStatus } from '~/domain/dicom/dicomConstants';
import { RoiReadModel } from '~/domain/readmodels/StructureSetReadModel';
import { selectedROIState } from '~/state/atoms/structureSet/roiAtoms';
import StructureDeletionConfirmationDialog from './StructureDeletionConfirmationDialog';
import StructureProperties from './StructureProperties';

export default function StructureLayer({ roi }: { roi: RoiReadModel }) {
    const roiFieldRef = useRef<HTMLDivElement | null>(null);
    const selectedROI = useRecoilValue<number>(selectedROIState);
    const ROINumber = roi.roiNumber;
    const isSelected = selectedROI === ROINumber;
    const structureCanBeDeleted =
        roi.approvalStatus !== DICOMApprovalStatus.APPROVED;

    return (
        <Box
            ref={roiFieldRef}
            display="flex"
            alignItems="center"
            data-structure-row
            data-roi-number={ROINumber}
            sx={(theme) => ({
                position: 'relative',
                background: isSelected
                    ? theme.palette.primary.contrastText
                    : 'none',
                '&:hover': {
                    backgroundColor: theme.palette.action.hover,
                },
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    bottom: 0,
                    width: 2,
                    bgcolor: isSelected ? 'primary.main' : 'transparent',
                    transition: 'background-color 0.15s ease-in-out',
                },
            })}
        >
            <StructureProperties roi={roi} />
            {structureCanBeDeleted && (
                <StructureDeletionConfirmationDialog
                    roi={roi}
                    isSelected={isSelected}
                />
            )}
        </Box>
    );
}
